export default (params) => ({
  trigger: {
    name: 'insurance_selector.select_insurance',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'add_to_cart_overlay',
          'add_to_cart_page',
          'shopping_cart',
          'employee_atc_page',
          'employee_ato_page',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'add_item',
      params: {
        list: null,
      },
    },
    nonInt: true,
  },
});
